module.exports = __webpack_public_path__ + "img/2_135.16e99055.png";